export default __webpack_public_path__ + "static/media/new-ugd-logo.b4e0bc8b.svg";